import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      nav(u.role === "admin" ? "/admin" : "/");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <main className="max-w-md mx-auto px-6 py-24" data-testid="login-page">
      <p className="overline opacity-60 mb-2">// Welcome back</p>
      <h1 className="font-display font-black text-4xl tracking-tighter mb-8">Sign in</h1>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <input className="input-sharp" type="email" placeholder="Email" value={email}
               onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
        <input className="input-sharp" type="password" placeholder="Password" value={password}
               onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
        <button className="btn-signal w-full justify-center" disabled={loading} data-testid="login-submit">
          {loading ? "Signing in…" : "Sign in →"}
        </button>
      </form>
      <p className="font-mono text-sm mt-6 opacity-70">
        New here? <Link to="/register" className="text-signal underline">Create an account</Link>
      </p>
    </main>
  );
}
